import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { HttpMethods } from 'consts/httpMethods';
import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertUserTypeRole } from 'modules/settings/api';

export const useMutationUpsertUserTypeRole = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, data } = useMutation(upsertUserTypeRole, {
    onSuccess: response => {
      const responseMethod = response?.config?.method;
      const name = response?.data?.name;
      let successMessage = '';

      if (responseMethod === HttpMethods.PUT) {
        successMessage = t('Partner successfully updated', { who: name });
      } else if (responseMethod === HttpMethods.POST) {
        successMessage = t('User type successfully created', { who: name });
      }
      successToast(successMessage);
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_UPSERT_USER_TYPE_ROLE);
    },
    onError: (_, { actions }) => {
      actions.setErrors({ typeOfUserRole: t('Type of user exists') });
      errorToast();
    },
    onSettled: () => queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_UPSERT_USER_TYPE_ROLE),
  });

  return {
    upsertUserTypeRoleMutate: mutateAsync,
    upsertUserTypeRoleLoading: isLoading,
    isUpsertUserTypeRoleError: isError,
    upsertUserTypeRoleData: data,
  };
};
